import { styled } from '@linaria/react';

import { uiToken } from '~/shared/constants/uiToken';
import { Button } from '~/shared/ui/Button/Button';

export const GAP = 4;
const BUTTON_HEIGHT = 40;
const COLLAPSED_HEIGHT = 6 * BUTTON_HEIGHT + 5 * GAP;

export const Root = styled.div`
  width: 100%;
  margin-top: 16px;
`;

export const List = styled.div<{ expanded: boolean; totalItems: number }>`
  display: flex;
  flex-direction: column;
  gap: ${GAP}px;
  overflow: hidden;
  transition: max-height 0.3s ease-in-out;
  max-height: ${({ expanded, totalItems }) =>
    expanded
      ? `${totalItems * BUTTON_HEIGHT + (totalItems - 1) * GAP}px`
      : `${COLLAPSED_HEIGHT}px`};
`;

export const ButtonItem = styled.button<{ active?: boolean }>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: ${({ active }) =>
    active
      ? `2px solid ${uiToken.color.border.glassActive}`
      : `0.5px solid ${uiToken.color.background.glass}`};
  background-color: ${({ active }) =>
    active
      ? uiToken.color.background.glassActive
      : uiToken.color.background.glass};
  height: ${BUTTON_HEIGHT}px;
  min-height: ${BUTTON_HEIGHT}px;
  cursor: pointer;
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease;
  position: relative;

  &:focus {
    outline: none;
  }

  &:focus-visible::before {
    content: ${({ active }) => (active ? 'none' : "''")};
    position: absolute;
    inset: 0;
    border: 2px solid ${uiToken.color.border.glassActive};
    border-radius: 10px;
    pointer-events: none;
  }
`;

export const MoreButton = styled(Button)<{ isExpanded: boolean }>`
  width: 100%;
  height: 40px;
  margin-top: 4px;
`;
